import React from 'react';

import Paper from '@mui/material/Paper';
import { useLiveQuery } from 'dexie-react-hooks';

import { CsvUploadForm } from 'client/app/apps/disco-prototype/components/CSVUploadForm';
import DatasetsTable from 'client/app/apps/disco-prototype/components/DatasetsTable';
import FlexContainer from 'client/app/apps/disco-prototype/components/FlexContainer';
import { discoPrototypeStore } from 'client/app/apps/disco-prototype/dataStore/dexieStore';

const Page = () => {
  const datasets = useLiveQuery(() => discoPrototypeStore.getDatasets(), []);
  const usedDatasetIds = useLiveQuery(async () => {
    const liquidsets = await discoPrototypeStore.getLiquidsets();
    return new Set(liquidsets.map(ls => ls.table));
  }, []);

  if (!datasets || !usedDatasetIds) return <div>Loading...</div>;

  return (
    <FlexContainer component={Paper}>
      <FlexContainer
        component={Paper}
        direction="column"
        sx={{ maxWidth: '400px', p: '16px 8px' }}
      >
        <CsvUploadForm />
      </FlexContainer>
      <FlexContainer direction="column" sx={{ flex: 1 }}>
        <DatasetsTable datasets={datasets} usedDatasetIds={usedDatasetIds} />
      </FlexContainer>
    </FlexContainer>
  );
};

export default Page;
